import config from 'constants/config'
import { initSentryClientSide, sendErrorToSentry } from '../lib/utils/sentryUtils'
import type { AppStore } from '../store'
import getReportDataFromState from 'reporting/utils/getReportDataFromState'
import type * as SentryReact from '@sentry/react'

let _store: AppStore | undefined

export function registerErrorReportStore(store: AppStore) {
  _store = store
}

let Sentry: typeof SentryReact | undefined
async function ensureSentry() {
  if (!Sentry) {
    Sentry = await import(/* webpackChunkName: "Sentry" */ '@sentry/react')
    initSentryClientSide(Sentry)
  }
}

export function reportClientError(error: unknown, additional: Record<string, any> = {}) {
  if (!config.SENTRY_ID) return Promise.resolve()

  const { account, meta } = getReportDataFromState(_store?.getState())
  const extras = { ...meta, ...additional }

  if (!config.APP_ENV || config.APP_ENV !== 'production') {
    console.warn('Client error reported:', error, account, extras)
  }

  return ensureSentry()
    .then(() => sendErrorToSentry(error, account, extras))
    .catch(() => { /* Sentry unavailable 😱 */ })
}

export function reportReactError(error: unknown, errorInfo: { componentStack?: string }) {
  if (!config.SENTRY_ID) return

  const { account, meta } = getReportDataFromState(_store?.getState())
  const extras = { ...meta, ...errorInfo }

  if (!config.APP_ENV || config.APP_ENV !== 'production') {
    console.warn('React error reported:', error, errorInfo)
  }

  return ensureSentry()
    .then(() => sendErrorToSentry(error, account, extras))
    .catch(() => { /* Sentry unavailable 😱 */ })
}
